import { useEffect, useContext, useState } from 'react'
import { gql, useQuery } from '@apollo/client';

import EnvContext from '../context/EnvContext'
import { ONE_MINUTE } from './pollIntervals';
// import { identity } from 'underscore';

const fixServiceTypeMapping = {
    '1':  'fixdropcopy',
    '2':  'fixorderrouting',
    '3':  'fixmarketdata',
}

const SESSION_SUBSCRIPTION = gql`
query ($envName: String!) {
    sessionFixView(where: {
      environmentName: {_eq: $envName}
    }
  ) {
        fixType
        fixSessionId
    }
}
`

const serviceLookup = {
    DropCopyClient : 'dropcopyclientnode',
    BackOffice : 'backofficenode',
    OrderRtg: 'orderrtgnode',
    SecDef: 'secdefnode',
    Miami: 'miaminode',
    RequestRecovery: 'requestrecovery',

    FIXInboundDropCopy: 'fixinbounddropcopy',
    FIXMarketData: 'fixmarketdata',
    FIXDropCopy: 'fixdropcopy',
    BinaryMarketData: 'binarymarketdata',
    FIXOrderRouting: 'fixorderrouting'
}

export const useFix = () => {

    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(SESSION_SUBSCRIPTION, {variables: {envName: envSelected}, pollInterval: ONE_MINUTE})

    

    useEffect(() => {
        if (!loading && data) {
            setLookupData(data.sessionFixView.reduce((acc, d) => {
                if (d)
                    acc[d.fixSessionId] = {
                        'type': serviceLookup[d.fixType],
                    }
                return acc
            }, {}))
        }
    }, [data, loading])

    return lookupData
}

const FIX_DATA = gql`
query FixConnectionToCompany($envName: String_comparison_exp!) {
    FixConnectionToCompany(where: {envName: $envName}) {
      companyName
      dtLastUp
      remoteCompHost
      remoteCompId
      remoteCompPort
      schedule
      targetCompId
      targetSubId
      fixName
      fixSessionId
      envName
      initiator
      notificationEmail
    }
  }  
`

export const useFixData = () => {

    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(FIX_DATA, {variables: {envName: {"_eq": envSelected}}, pollInterval: ONE_MINUTE})

    

    useEffect(() => {
        if (!loading && data) {
            setLookupData(data.FixConnectionToCompany.reduce((acc, d) => {
                if (d)
                    acc[d.fixSessionId] = {
                        'companyName': d.companyName,
                        'fixName': d.fixName,
                        'remoteCompId': d.remoteCompId,
                        'remoteCompHost': d.remoteCompHost,
                        'remoteCompPort': d.remoteCompPort,
                        'dtLastUp': d.dtLastUp,
                        'targetCompId': d.targetCompId,
                        'targetSubId': d.targetSubId,
                        'schedule': d.schedule,
                        'initiator': d.initiator,
                        'notificationEmail': d.notificationEmail
                    }
                return acc
            }, {}))
        }
    }, [data, loading])

    return lookupData
}



const HAPFIXROUTES = gql`
query HAProxyFixRoutesQuery($envName: String_comparison_exp!) {
    HAProxyFIXRoutes(where: {envName: $envName}) {
        routingLabel
        blocked
        envName
        fixSessionId
        fixSessionType
        instanceId
        senderCompId
    }
  }  
`

export const useHAProxyFixRoutesOld = () => {

    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(HAPFIXROUTES, {variables: {envName: {"_eq": envSelected}}, pollInterval: ONE_MINUTE})

    useEffect(() => {
        if (!loading && data) {
            setLookupData(data.HAProxyFIXRoutes.reduce((acc, d) => {
                if (d)
                    acc[d.fixSessionId] = {
                        "routingLabel": d.routingLabel,
                        "blocked": d.blocked,
                        "fixSessionId": d.fixSessionId,
                        "fixSessionType": d.fixSessionType,
                        "instanceId": d.instanceId,
                        "senderCompId": d.senderCompId
                    }
                return acc
            }, {}))
        }
    }, [data, loading])

    return lookupData
}

const SERVICEGROUPNODE2 = gql`
query SERVICEGROUPNODEQUERY2($envName: String!) {
    serviceGroup_node(where: {serviceGroup: {group: {_like: "fixadapter-%"}}, node: {environment: {name: {_eq: $envName}}}}) {
        hostname: chef(path: "hostname")
    	fixdropcopy_instance_identifier: chef(path: "fixdropcopy.instance_identifier")
        fixmarketdata_instance_identifier: chef(path: "fixmarketdata.instance_identifier")
        fixorderrouting_instance_identifier: chef(path: "fixorderrouting.instance_identifier")
    }
  }
`

export const useHAProxyFixRoutes = () => {

    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(HAPFIXROUTES, {variables: {envName: {"_eq": envSelected}}, pollInterval: ONE_MINUTE})

    const [fixInstNodeMap, setHostNameFromChef] = useState({})
    const serviceGroupNodeResult = useQuery(SERVICEGROUPNODE2, {variables: {envName: envSelected}, pollInterval: ONE_MINUTE})
    useEffect(() => {
        if (!serviceGroupNodeResult.loading && serviceGroupNodeResult.data 
                && serviceGroupNodeResult.data.serviceGroup_node  && serviceGroupNodeResult.data.serviceGroup_node.length > 0
            ) 
        {   
            if (serviceGroupNodeResult.data.serviceGroup_node!== null) {
                serviceGroupNodeResult.data.serviceGroup_node.forEach(item => {
                    if (item.fixdropcopy_instance_identifier ){
                        let key = "fixdropcopy_" + item.fixdropcopy_instance_identifier
                        fixInstNodeMap[key] = item.hostname
                    }

                    if (item.fixorderrouting_instance_identifier){
                        let key = "fixorderrouting_" + item.fixorderrouting_instance_identifier
                        fixInstNodeMap[key] = item.hostname
                    }

                    if (item.fixmarketdata_instance_identifier ){
                        let key = "fixmarketdata_" + item.fixmarketdata_instance_identifier
                        fixInstNodeMap[key] = item.hostname
                    }

                })
                //console.log("fixInstNodeMap =", fixInstNodeMap)
                setHostNameFromChef(fixInstNodeMap)
            }
        }
        //else console.log("fixInstNodeMap is not populated")
    }, [serviceGroupNodeResult.loading, serviceGroupNodeResult.data, fixInstNodeMap])


    useEffect(() => {   
        if (!loading && data && fixInstNodeMap) {
            setLookupData(data.HAProxyFIXRoutes.reduce((acc, d) => {
                let derivedRoutingLabel = ""
                //console.log("   fixSessionId, routingLabel & instance_id from DB = ", d.fixSessionId, d.routingLabel, d.instanceId)
                // refer logic from deploy/chef/cookbooks/tthaproxy/templates/default/fixroute.py.erb

                // # Group Label in a TTUS service container (Servers) start with "c" followed by a number
                // # for the company id. If we don't see this pattern then the label is set under
                // # FIX Sessions "Routing Label"
                const pattern = new RegExp("^cd+-")
                let fixsvc =  fixServiceTypeMapping[d.fixSessionType]

                if (d.fixSessionId && d.fixSessionType !== 4){

                    //# Verify the FIX dedicated instance is deployed in Chef
                    if (d.instanceId !== '' && d.instanceId !==null && typeof d.instanceId !== 'undefined')
                    {
                        let search_key = (fixsvc +"_" + d.instanceId).trim()  
                        let node_name = fixInstNodeMap[search_key]
                        //console.log("fixInstNodeMap=>",fixInstNodeMap)
                        //console.log("search_key used=",search_key)
                        //console.log("Value from chef = ",node_name)

                        // if (node_name === "" || node_name === null || typeof node_name === 'undefined') {
                        //     console.log("node with fix_instance_id is not found in Chef")
                        // }
                        // else {
                        //     console.log("Node=",node_name,"fix_instance_identifier=", d.instanceId, "sender_comp_id=", d.senderCompId, "routing_label=", d.routingLabel)
                        // }

                        if (d.routingLabel === "" && node_name !== ""){
                            // # TTUS Servers "Routing Group" is left empty so this is a
                            // # cluster of one dedicated FIX node.
                            derivedRoutingLabel = fixsvc + "_" +node_name
                        }
                    }  
                    
                    // # A routing label set in the TTUS "FIX Sessions" page should follow the naming
                    // # convention "fixservice_nodename" ("fixdropcopy_gla1vm47") to prevent a name
                    // # collision if multiple services are deployed on the same node
                    if(d.routingLabel !== "" && !pattern.test(d.routingLabel) && !d.routingLabel.startsWith(fixsvc)){
                        derivedRoutingLabel = fixsvc + "_" + d.routingLabel
                    }

                    // # don't add mappings for <unknown> routes
                    if(d.routingLabel === "" ){
                        //console.log("Invalid routing_label for sender_comp_id=",d.senderCompId, "fix_instance_identifier=",d.instanceId,"routing_label=",d.routingLabel)
                    }

                    //# warn if the routing_label is not configured in haproxy.cfg as a backend
                    // TODO

                }
                //console.log("derivedRoutingLabel FINALLY = ", derivedRoutingLabel)

                if (d)
                    acc[d.fixSessionId] = {
                        "routingLabel": d.routingLabel,
                        "blocked": d.blocked,
                        "fixSessionId": d.fixSessionId,
                        "fixSessionType": d.fixSessionType,
                        "instanceId": d.instanceId,
                        "senderCompId": d.senderCompId,
                        "derivedRoutingLabel": derivedRoutingLabel
                    }
                return acc
            }, {}))
        }
    }, [data, loading, fixInstNodeMap])

    return lookupData
}
